import VForm from '@/vuetify_custom/v-form'
import {status_list, search_type_list} from '@/views/hr/PaymentManage/fields.js'
export default {
    props: {
        value: {
            type: Object
        },
        showPersonSelect: {
            type: Boolean
        },
        showDataRange: {
            type: Boolean
        },
        searchTypeList: {
            type: Array,
            default: () => search_type_list
        }
        
    },
    data() {
        return {
            params: this.value
        }
    },
    computed: {
        isStarter() {
           
            const current_hash = this.$store.state.hash_authority || {}
            return current_hash['pay_flow_manager']
          },
        form_fields() {
            return [
                {
                    label: '状态', 
                    key:'status',
                    type:'select_field',
                    'item-text': 'label',
                    'item-value': 'value',
                    cols:3,
                    items:status_list.filter(i => {
                      if (i.value === 'edit') {
                        return !!this.isStarter
                      }
                      return true
                    }),
                    show: true,
                    change:this.change
                },
                {
                    label: '分类', 
                    key:'search_type',
                    type:'select_field',
                    'item-text': 'label',
                    'item-value': 'value',
                    items:this.searchTypeList,
                    cols:3,
                    show: true,
                    change:this.change
                },
                {
                    label: '员工',
                    key:'customer_id',
                    out_params: {
                        formal: true,
                    },
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'dis_text',
                    api: this.$util.api.customer_select_search,
                    show: this.showPersonSelect,
                    cols:3, 
                    clearable: true,
                    
                    handle_data:({customers}) => {
                        customers = customers || []
                        return customers.map(i => {
                            return {
                                ...i,
                                dis_text: `${i.account}/${i.team_name}`
                            }
                        })
                    },
                    change:this.change
                },
                {
                    label: '月份',
                    key:'month',
                    type:'month_field',
                    cols: 3,
                    prependIcon: '',
                    selected_close: true,
                    show: this.showDataRange,
                    change:this.change
                },
            ].filter(i => i.show)
        }
    },
    watch: {
        value(val) {
            this.params = val
        },
        params(val) {
            this.$emit('input', val)
        }
    },
    methods: {
        change() {
            this.$emit('change')
        }
    },
    render() {
        return <VForm 
            ref="form" 
            fields={this.form_fields} 
            v-model={this.params}
        />
    }
}